import {Component, OnInit} from '@angular/core';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService, OrderService} from '@app/shared/services';
import {CommonModule, DecimalPipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {NgbHighlight, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {UtilsInjectable} from '@app/shared';

@Component({
  selector: 'app-add-combo-products',
  templateUrl: './add-combo-products.component.html',
  imports: [
    CommonModule,
    FormsModule,
    DecimalPipe,
    NgbTypeahead,
    NgbHighlight,
    PageHeaderComponent
  ],
  styleUrls: ['./add-combo-products.component.scss']
})
export class AddComboProductsComponent implements OnInit {


  user_rights: any;
  user_data: any;
  public combo_details: any = ["0"];
  public combo: any =
    {
      description: "",
      combo_description_id: '',
      medicine_data: [],
      medicine_id_arr: [""],
      base_price: [""],
      available_qty: [""],
      quantity: ["1"],
      slab: [""],
      slab_price: [""],
      price: [""],
      MRP: [""],
      margin: [""],
      mrp: [""],
      cost: [""],
      purchase_details_id: [""],
      user_id: '',
    }
  searching = false;
  searchFailed = false;
  slab: any;
  total_price = 0;
  total_cost = 0;
  total_mrp = 0;
  total_margin = 0;

  constructor(private loaderService: LoaderService,
              public orderService: OrderService,
              private toastr: ToastrService,
              public consultingService: ConsultingService,
              protected utils: UtilsInjectable) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
  }

  public set_item_medicine($event: any, i: any) {
    this.combo.medicine_id_arr[i] = ""
    this.combo.base_price[i] = ""
    this.combo.available_qty[i] = ""
    this.combo.MRP[i] = ""
    this.combo.mrp[i] = ""
    this.combo.cost[i] = ""
    this.combo.purchase_details_id[i] = ""
    this.combo.slab[i] = ""
    this.combo.slab_price[i] = ""
    this.combo.quantity[i] = "1"
    const item = $event.item;
    this.combo.medicine_id_arr[i] = item.MEDICINE_ID;
    this.combo.base_price[i] = item.UNIT_PRICE;
    this.combo.available_qty[i] = item.AVAILABLE_STOCK_QUANTITY;
    this.combo.MRP[i] = item.MRP;
    this.combo.mrp[i] = item.MRP;
    this.combo.purchase_details_id[i] = item.PURCHASE_DETAILS_ID;
    this.getPrice(i);
    this.totalPrice();
  }

  public getSlab(i: any): any {
    if (this.combo.purchase_details_id[i] == '') {
      this.toastr.error("Please select a product")
      return false;
    }
    if (this.combo.slab[i] > 0) {
      const postData = {
        purchase_details_id: this.combo.purchase_details_id[i]
      };
      this.loaderService.display(true);
      this.consultingService.getSlab(postData).subscribe((result: any) => {
        if (result['status'] == 'Success') {
          this.slab = result['data'];
          if (this.combo.slab[i] == 1) {
            this.combo.slab_price[i] = this.slab.SLAB_A_AMOUNT
          }
          if (this.combo.slab[i] == 2) {
            this.combo.slab_price[i] = this.slab.SLAB_B_AMOUNT
          }
          if (this.combo.slab[i] == 3) {
            this.combo.slab_price[i] = this.slab.SLAB_C_AMOUNT
          }
          this.loaderService.display(false);
          const slabPrice = parseFloat(this.combo.slab_price[i]);
          const qty = parseInt(this.combo.quantity[i]);
          const MRP = parseFloat(this.combo.mrp[i]);
          const base = parseFloat(this.combo.base_price[i]);

          if (!isNaN(slabPrice) && qty) {
            this.combo.price[i] = qty * slabPrice;
          }
          if (!isNaN(MRP && qty)) {
            this.combo.MRP[i] = MRP * qty;
          }
          if (!isNaN(base && qty)) {
            this.combo.cost[i] = base * qty;
          }
          const price = parseFloat(this.combo.price[i]);
          const cost = parseFloat(this.combo.cost[i]);
          if (!isNaN(price && cost) && price > 0) {
            this.combo.margin[i] = Math.round(price - cost);
          } else {
            this.combo.margin[i] = 0
          }
          this.totalprice();
        } else {
          this.loaderService.display(false);
        }
      });
    } else {
      this.toastr.error("Please select a slab")
    }
    this.totalprice();
  }

  public getPrice(i: any) {
    const qty = parseFloat(this.combo.quantity[i]);
    const slabPrice = parseFloat(this.combo.slab_price[i]);
    const base = parseFloat(this.combo.base_price[i]);

    if (slabPrice > 0) {
      this.combo.price[i] = qty * slabPrice;
    }
    if (!isNaN(base && qty)) {
      this.combo.cost[i] = qty * base;
    }
    const price = parseFloat(this.combo.price[i]);
    const cost = parseFloat(this.combo.cost[i]);
    if (!isNaN(price && cost) && price > 0) {
      this.combo.margin[i] = Math.round(price - cost);
    } else {
      this.combo.margin[i] = 0
    }
  }

  public totalprice() {
    let sum = 0
    let costs = 0
    let mrps = 0
    let marge = 0
    this.combo.quantity.forEach((_item: any, index: any): any => {
      if (parseInt(this.combo.quantity[index]) > 0 && this.combo.medicine_id_arr[index] > 0) {
        const slabPrice = parseFloat(this.combo.slab_price[index]);
        const qty = parseInt(this.combo.quantity[index]);
        const MRP = parseFloat(this.combo.mrp[index]);
        const MP = parseFloat(this.combo.MRP[index]);
        const cost = parseFloat(this.combo.cost[index]);
        const base = parseFloat(this.combo.base_price[index]);
        const margin = parseFloat(this.combo.margin[index]);
        if (!isNaN(slabPrice) && qty) {
          this.combo.price[index] = qty * slabPrice;
        }
        const price = parseFloat(this.combo.price[index]);
        if (!isNaN(MRP && qty)) {
          this.combo.MRP[index] = MRP * qty;
        }
        if (!isNaN(base && qty)) {
          this.combo.cost[index] = (base * qty).toFixed(2);
        }
        if (!isNaN(price && cost) && price > 0) {
          this.combo.margin[index] = Math.round(price - cost);
        } else {
          this.combo.margin[index] = 0
        }
        if (!isNaN(price)) {
          sum = sum + price;
        }
        if (!isNaN(cost)) {
          costs = costs + cost;
        }
        if (!isNaN(MP)) {
          mrps = mrps + MP;
        }
        if (!isNaN(margin)) {
          marge = marge + margin;
        }
      }
    });
    this.total_price = Math.round(sum);
    this.total_cost = Math.round(costs);
    this.total_mrp = Math.round(mrps);
    this.total_margin = Math.round(marge);
  }

  public saveComboProduct(): any {
    if (this.combo.description == '') {
      this.toastr.error('Please Enter description !');
      return false;
    }
    this.combo.user_id = this.user_data.user_id
    this.loaderService.display(true);
    this.consultingService.saveComboProduct(this.combo).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success( result.msg);
        this.clear_combo();
      } else {
        this.toastr.error( result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public totalPrice() {
    let sum = 0;
    let costs = 0;
    let mrps = 0;
    this.combo.price.forEach((_item: any, index: any): any => {
      const amount = parseFloat(this.combo.price[index]);
      const cost = parseFloat(this.combo.cost[index]);
      const mrp = parseFloat(this.combo.MRP[index]);
      if (!isNaN(amount)) {
        sum = sum + amount;
      }
      if (!isNaN(cost)) {
        costs = costs + cost;
      }
      if (!isNaN(mrp)) {
        mrps = mrps + mrp;
      }
    });
    this.total_price = Math.round(sum);
    this.total_cost = Math.round(costs);
    this.total_mrp = Math.round(mrps);
  }

  public clear_combo() {
    this.total_price = 0;
    this.total_cost = 0;
    this.total_mrp = 0;
    this.combo_details = [""];
    this.combo = {
      description: "",
      combo_description_id: '',
      medicine_data: [],
      medicine_id_arr: [""],
      base_price: [""],
      available_qty: [""],
      quantity: ["1"],
      slab: [""],
      slab_price: [""],
      price: [""],
      cost: [""],
      MRP: [""],
      margin: [""],
      mrp: [""],
      purchase_details_id: [""],
      user_id: '',
    }
  }

  public addrow(index: any) {
    this.combo_details[index + 1] = 0
    this.combo.medicine_data[index + 1] = '';
    this.combo.base_price[index + 1] = '';
    this.combo.available_qty[index + 1] = '';
    this.combo.MRP[index + 1] = '';
    this.combo.purchase_details_id[index + 1] = '0';
    this.combo.slab[index + 1] = '';
    this.combo.slab_price[index + 1] = '';
    this.combo.quantity[index + 1] = '1';
    this.totalprice();
  }

  public deleterow(index: any) {
    this.combo_details.splice(index, 1);
    this.combo.medicine_data.splice(index, 1);
    this.combo.medicine_id_arr.splice(index, 1);
    this.combo.base_price.splice(index, 1);
    this.combo.available_qty.splice(index, 1);
    this.combo.MRP.splice(index, 1);
    this.combo.purchase_details_id.splice(index, 1);
    this.combo.slab.splice(index, 1);
    this.combo.slab_price.splice(index, 1);
    this.combo.cost.splice(index, 1);
    this.combo.price.splice(index, 1);
    this.combo.quantity.splice(index, 1);
    this.totalprice();

  }

  medicine_search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.orderService.medicine_combo_search(term).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([])
          })
        )
      ),
      tap(() => this.searching = false)
    )
  formatter = (x: any): any => x.TRADE_NAME;
}
